export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {}
  },
  uiSchema: {
    text_123456789: {
      'ui:title': 'Static text defined using the ui:title inside the uiSchema'
    },
    text_escape1: {
      'ui:title': '<i>Escaped</i> static text (default)'
    },
    text_escape2: {
      'ui:title': {
        text: '<i>Explicitly escaped</i> static text',
        escape: true
      }
    },
    text_escape3: {
      'ui:title': {
        text: '<i>Unescaped</i> static text',
        escape: false
      }
    },
    text_helpText1: {
      'ui:title': 'Static text with associated help in tooltip. See "Help" stories for more examples.',
      'ui:help': {
        text: 'Help text displayed in a tooltip',
        escape: true
      }
    },
    'dm:layout': [{
      type: 'text',
      escape: false,
      text: 'Old static text approach - text is found inside dm:layout',
      id: 'text1'
    }, {
      type: 'text',
      id: 'text_123456789'
    }, {
      type: 'text',
      id: 'text_escape1'
    }, {
      type: 'text',
      id: 'text_escape2'
    }, {
      type: 'text',
      id: 'text_escape3'
    }, {
      type: 'text',
      id: 'text_helpText1'
    }]
  },
  formData: {}
};